import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { create } from 'jss';
import rtl from 'jss-rtl';
import {
  StylesProvider,
  jssPreset,
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import baseStyles from './styles';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const ThemeRtlProvider = ({ children, location }) => {
  const queryParams = new URLSearchParams(location.search);
  const lang = queryParams.get('lang');
  const direction = lang === 'ar' ? 'rtl' : 'ltr';

  const theme = createMuiTheme({
    ...baseStyles,
    direction,
  });

  useEffect(() => {
    document.body.dir = direction;
  }, [direction]);

  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </StylesProvider>
  );
};

ThemeRtlProvider.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};
export default withRouter(ThemeRtlProvider);
